import toastr from 'share/services/toastr'
import { I18n } from 'share/services/i18n'

export default ['utils', (utils) => ({
  scope: false,
  link($scope, $element, $attrs) {
      $element.find('input[type=file]').on('change', e => {
        let file = e.target.files[0];
        if(!file) return;
        let data = new FormData();
        data.append('file', file);
        utils.startLoadingBar();
        $.ajax({
          url: $attrs.evaAlarmAttachment,
          method: 'POST',
          data: data,
          // tell jQuery not to process the data
          // tell jQuery not to set contentType
          processData: false, contentType: false,
          success() {
            $scope.$eval($attrs.onSuccess);
          },
          error(json) {
            let errors = (json.responseJSON || {}).errors;
            if (json.status === 413) {
              window.scroll({ top: 0, behavior: 'smooth' });
              toastr(I18n.t('ui.eva_uploader.reached_max_file_size'), { theme: 'danger' });
            } else if (errors && errors.attachments && errors.attachments.length > 0) {
              window.scroll({ top: 0, behavior: 'smooth' });
              toastr(errors.attachments.join('. '), { theme: 'danger' });
            }
          },
          complete() {
            utils.completeLoadingBar();
          }
        });
      });
    }
})];
